(function () { if (!LN.Core) throw new Error("LN.Core missing"); })();

(function (Analytics, Helper, Config, Model) {
    'use strict';

    $(document.body).on('click', '.event-track', function (e) {
        e.preventDefault();
        var href = $(this).attr('href');
        var label = $(this).data('label');
        Analytics.otrosEnlaces(Helper.getSource(), label);
        window.location = href;
    });

   
    /*
    $(window).on('beforeunload', function(){
        return 'Desea salir?';
    });
    */

    $(window).on('unload', function () {
        var currentStep = Helper.getCurrentStep();
        if (Helper.isEmpty(currentStep)) return;
        var forms = Config.Blocks[currentStep.toUpperCase()].forms;
        if (!Helper.isEmpty(forms)) {
            for (var index in forms) {
                var inputs = Model.getInputsBy(forms[index]).all();
                if (typeof inputs === 'object') {
                    for (var i in inputs) {
                        if (Helper.isEmpty(inputs[i].value)) {
                            Analytics.onBeforeUnload(inputs[i].name, null);
                        }
                    }
                }
            }
        }
        return;
    });


    /*
    -- 3
    Medición de pageviews virtuales durante Sign Wall
    Conforme el usuario avanza en los distintos procesos relacionados con la
    autenticación, se le presentarán diversas instancias del formulario mediante ajax y
    sin cambio en la URL. Es por ello que cada una de ellas se deberá medir mediante
    páginas virtuales, siguiendo el siguiente esquema:
    */

    Analytics.paginaVirtualSignWall = function (page) {
        Analytics.pushData({
            'event': 'trackPageView',
            'pageName': page  // Pagina actual   
        })
    }

    /*
    -- 4
    Interacciones con botones de SSO
    El usuario dispone a lo largo del flujo de botones para acceder a La Nación mediante
    Google o Facebook, tales como los que se muestran a continuación:    
    */

    Analytics.clickSSO = function (method) {
        Analytics.pushData({
            'event': 'trackClickSSO',
            'login-method': method  // Google, Facebook  
        })
    }

    /*
    -- 5
    Estos acontecimientos deben ser medidos mediante la ejecución de una sentencia
    push al momento en que se muestra la alerta de dicho error al usuario. La interacción
    se medirá como un evento estándar en Analytics, a través de Google Tag Manager,
    como se observa en el Snippet que se encuentra a continuación.    
     */

    Analytics.formError = function (label) {
        Analytics.pushData({
            'event': 'trackEvent',
            'eventCategory': 'carrito-paywall',
            'eventAction': 'error-form',
            'eventLabel': label,
        })
    }


    /*
    -- 7
    Un usuario puede abandonar un paso del formulario –tanto de SignWall como de
    PayWall– sin avanzar a la siguiente pantalla, ni retroceder al anterior. Si lo hace, debe
    registrarse mediante un push al dataLayer dicho acontecimiento.
    */

    Analytics.onBeforeUnload = function (empty, error) {
        Analytics.pushData({
            'event': 'trackAbandonment',
            'flow': 'carrito-paywall',
            'emptyFields': empty,
            'errorFields': error
        })
    }


    /*
    -- 8
    Una página virtual es un contenido nuevo que se le carga al usuario, pero que
    no recarga la totalidad de la página (No recarga por ejemplo el código de GTM). En
    consecuencia para medirlos será necesario utilizar un push al dataLayer con los
    siguientes datos:
    */

    Analytics.error = function (error) {
        Analytics.pushData({
            'event': 'trackErrorPageV',
            'flow': 'carrito-paywall',
            'errorType': error,
            'errorPage': true
        })
    }


    /*
    -- 9
    Una página virtual es un contenido nuevo que se le carga al usuario, pero que
    no recarga la totalidad de la página (No recarga por ejemplo el código de GTM). En
    consecuencia para medirlos será necesario utilizar un push al dataLayer con los
    siguientes datos:
    */
    Analytics.login = function (isNew, method, id) {
        Analytics.pushData({
            'event': 'trackLogin',
            'newUser': isNew,
            'loginMethod': method, // Facebook,Google,Mail
            'userID': id,
        })
    }



    /* 
     -- 11.1
    Tanto en el Muro como en la Landing de PayWall se espera que el usuario cliquee
    sobre los CTA de los paquetes. Esta medición también aplicará para la pantalla de
    “plan insuficiente” (G.05) y para la de “Muro sin Combo
    */

    Analytics.clickCombo = function (name, price, list) {
        Analytics.pushData({
            'event': 'trackClickProd',
            'name': name,
            'price': price,
            'list': list
        })
    }

    /* 
    -- 11.2
    Tanto en el Muro como en la Landing de PayWall, si el usuario ya es Premium o
    Black, puede continuar sin cargo. Esta medición también aplicará para la pantalla
    de “plan insuficiente” (G.05) y para la de “Muro sin Combo”    
    */

    Analytics.clickCombo3 = function (list) {
        Analytics.pushData({
            'event': 'trackEvent',
            'eventCategory': 'paywall',
            'eventLabel': 'Continuar sin cargo',
            'eventAction': list
        })
    }

    /* 
    -- 11.3
    */

    Analytics.otrosEnlaces = function (modo, label) {
        Analytics.pushData({
            'event': 'trackPage',
            'eventCategory': 'paywall',
            'eventAction': modo, // Indicará según corresponda uno de los siguientes strings: muro  landing pantalla plan insuficiente muro-sin-combo 
            'eventLabel': label // Se indicará según corresponda uno de los siguientes strings: logo header //  volver // mas informacion // mail
        })
    }

    Analytics.clickValidarPin = function (label) {
        Analytics.pushData({
            'event': 'trackEvent',
            'eventCategory': 'Código de Activación',
            'eventLabel': label 
        })
    }

    Analytics.clickYaTengoSuscripcion = function () {
        Analytics.pushData({
            'event': 'trackEvent',
            'eventCategory': 'Ya tengo suscripcion',
            'eventLabel': 'Ya tengo suscripcion'
        })
    }

    /* 
    -- 12
    Una página virtual es un contenido nuevo que se le carga al usuario, pero que
    no recarga la totalidad de la página (No recarga por ejemplo el código de GTM). En
    consecuencia para medirlos será necesario utilizar un push al dataLayer con los
    siguientes datos
    */

    Analytics.paginaVirtual = function (name, product) {
        Analytics.pushData({
            'event': 'trackPage',
            'pageName': name,  // Pagina actual   
            'checkoutProd': product != null ? product : ''
        })
    }


    /* 
    -- 13
    Durante el Flujo del Checkout será necesario enriquecer la información de la página
    medida agregando el key “checkout” informado en el apartado 12, que consistirá en
    un objeto con información adicional
    */

    Analytics.medicionCheckOut = function (name, price) {
        Analytics.pushData({
            'event': 'page',
            'pageName': Model.Window.currentStep,  // Pagina actual   
            'checkout': {
                'name': name, // Indicará un string con el nombre del paquete, por ejemplo: Acceso Digital
                'price': price // Valor de la suscripción.
            },

        })
    }


    /* 
    -- 14
    Si bien la medición de transacciones en Google Analytics se realizará directamente
    desde backend para reducir las inconsistencias de la herramienta, es una buena
    práctica contar con una medición desde front end disponible en el dataLayer para
    eventualmente aprovechar las ventajas de la medición vía GTM con otras
    herramientas (Por ejemplo: Facebook, Adwords, etc.).
    */

    Analytics.transaccionExitosa = function (name, price, started) {
        Analytics.pushData({
            'event': 'trackTransaction',
            'name': name,  // Indicará un string con el nombre del paquete, por ejemplo: Acceso Digital     
            'price': price, // Valor de la suscripción
            'started': started, // Indicará con un string la letra del flujo por el cual inició. Por ejemplo: B
            'article': Model.Window.paginaId
        })
    }


    /* 
    -- 15
    Cuando un usuario ya tiene contratado un producto puede asociar el mismo para
    continuar sin cargo consumiendo contenidos al observar el muro. El éxito del proceso
    de asociación será medido aplicando una sentencia push al dataLayer, que incluirá
    los siguientes atributos:
    */

    Analytics.asociacionExitosa = function (type, started) {
        Analytics.pushData({
            'event': 'trackAccountLink',
            'accountType': type,  // Indicará un string con el nombre del servicio que tiene el usuario, por ejemplo: Black       
            'started': started // Indicará con un string la letra del flujo por el cual inició. Por ejemplo: B
        })
    }


    Analytics.trackViewPaywall = function () {
        Analytics.pushData({
            'event': 'trackViewPaywall'
        })
    }

    /* CALL */
    Analytics.pushData = function (data) {
        (typeof dataLayer !== 'undefined') && dataLayer && dataLayer.push(data)
    }

})(LN.Analytics, LN.Helper, LN.Config, LN.Model);


// WEBPACK FOOTER //
// ./Statics/scripts/paywall/core/analytics.js